export enum DefaultVmNodeDisplay {
  x1 = -45,
  y1 = 25,
}
